import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  FormControlLabel,
  Grid2,
  IconButton,
  Switch,
  Button,
  Typography,
} from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSelect from "../../../../components/MaterialSelect";
import colors from "../../../../assest/theme/base/colors";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import MessagePopup from "../../../Utils/MessagePopup";
import ConfirmDialog from "../../../Utils/ConfirmDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import axiosInstance, { API_URL, FILE_URL } from "../../../Utils/url";
import { useSnackbar } from "../../../../components/SnackbarProvider";
import { useLoading } from "../../../../context/loadingcontext";

const AddInsurance = ({ formClose, formType, setOpen, rowId }) => {
  const [insurerdata, setinsurerdata] = useState({
    insurancename: "",
    insuranceType: "",
    parentpolicyno: "",
    planName: "",
    todate: "",
    fromdate: "",
    uploadedFile: null,
    parentpolicyfile: null,
    active: false,
    insurancenameStatus: "unchecked",
    insuranceTypeStatus: "unchecked",
    todateStatus: "unchecked",
    fromdateStatus: "unchecked",
    parentpolicynoStatus: "unchecked",
    planNameStatus: "unchecked",

    imageUrl: null,
    pdfUrl: null,
  });
  const [insurenceType, setInsurenceType] = useState([]);
  const [inputStatus, setinputStatus] = useState(false);
  const { showSnackbar } = useSnackbar();
  const { setCirleLoading } = useLoading();

  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [entries, setEntries] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    fetchInsurencetype();
  }, [dialogOpen]);

  useEffect(() => {
    if (formType == "view") {
      setinputStatus(true);
    } else {
      setinputStatus(false);
    }
    fetchInsurencetypeById();
  }, [formType]);

  const fetchInsurencetypeById = async () => {
    try {
      const response = await axiosInstance.get(
        `${API_URL}v1/insurance-configuration/${rowId}/`
      );

      const success = response?.data?.success;
      const data = response?.data?.data;
      setEntries(data?.plans);

      setinsurerdata({
        insurancename: data?.insurance_name,
        insuranceType: {
          value: data?.insurance_type_id,
          label: data?.insurance_type,
        },
        parentpolicyno: data?.policy_number,
        planName: "",
        todate: data?.validate_to,
        fromdate: data?.validate_from,
        uploadedFile: null,
        parentpolicyfile: null,
        active: data?.is_active,
        insurancenameStatus: "success",
        insuranceTypeStatus: "success",
        todateStatus: "success",
        fromdateStatus: "success",
        parentpolicynoStatus: "success",
        planNameStatus: "success",
        imageUrl: `${FILE_URL}${data?.insurance_logo}`,
        pdfUrl: `${FILE_URL}${data?.policy_file}`,
      });
    } catch (err) {
    } finally {
    }
  };

  const fetchInsurencetype = async () => {
    try {
      const response = await axiosInstance.get(`${API_URL}v1/insurance-type/`);

      const success = response?.data?.success;

      if (success) {
        setInsurenceType(response?.data?.data);
      } else {
        setInsurenceType([]);
      }
    } catch (err) {
      setInsurenceType([]);
    } finally {
    }
  };

  const handleAddCourseChange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...insurerdata };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "clientname") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "insuranceType") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "insurancename":
          {
            const alphaNLengthRegex = new RegExp("^.{1,30}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "parentpolicyno":
          {
            const alphaNLengthRegex = new RegExp("^.{1,30}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "planName":
          {
            const alphaNLengthRegex = new RegExp("^.{1,30}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "todate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "fromdate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setinsurerdata(formState);
  };

  const hanldeConfirmDialogCancel = () => {
    setDialogOpen(false);
  };

  const handleSubmit = () => {
    setDialogOpen(true);
  };

  const reset = () => {
    setinsurerdata({
      ...insurerdata,
      insurancename: "",
      insuranceType: "",
      parentpolicyno: "",
      planName: "",
      uploadedFile: null,
      parentpolicyfile: null,
      active: true,
      insurancenameStatus: "unchecked",
      parentpolicynoStatus: "unchecked",
      insuranceTypeStatus: "unchecked",
      planNameStatus: "unchecked",
    });
    setEntries([]);
    formClose();
  };

  const isFormValid = () => {
    return insurerdata.insurancenameStatus == "success";
  };

  const hanldeConfirmDialogSubmit = async () => {
    setDialogOpen(false);
    setCirleLoading(true);
    try {
      const planNames = entries?.map((entry) => ({
        plan_name: entry.plan_name,
      }));

      const formData = new FormData();

      formData.append("insurance_name", insurerdata?.insurancename);
      formData.append("insurance_type", insurerdata?.insuranceType?.value);
      formData.append("policy_number", insurerdata?.parentpolicyno);
      formData.append("validate_from", insurerdata?.fromdate);
      formData.append("validate_to", insurerdata?.todate);
      formData.append("is_active", insurerdata?.active);
      formData.append("insurance_plans", JSON.stringify(planNames));
      if (insurerdata?.parentpolicyfile?.name) {
        formData.append("policy_file", insurerdata.parentpolicyfile);
      }

      if (insurerdata?.uploadedFile?.name) {
        formData.append("insurance_logo", insurerdata.uploadedFile);
      }

      const response =
        formType == "edit"
          ? await axiosInstance.put(
              `${API_URL}v1/insurance-configuration/${rowId}/`,
              formData
            )
          : await axiosInstance.post(
              `${API_URL}v1/insurance-configuration/`,
              formData
            );
      setOpen(false);
      showSnackbar(response?.data?.message, "success");
    } catch (err) {
      showSnackbar(err?.response?.data?.message, "error");
    } finally {
      setCirleLoading(false);
    }
  };

  const handleToggleActive = () => {
    setinsurerdata((prev) => ({
      ...prev,
      active: !prev.active,
    }));
  };

  const handleDeleteEntry = (indexToDelete) => {
    setEntries((prev) => prev.filter((_, i) => i !== indexToDelete));
  };

  const handleAddEntry = () => {
    const { planName, planNameStatus } = insurerdata;

    // Validation
    if (planNameStatus !== "success" || !planName.trim()) {
      return;
    }

    // Append to entries array
    setEntries((prev) => [...prev, { plan_name: planName }]);

    // Clear input fields
    setinsurerdata({
      ...insurerdata,
      planName: "",
      planNameStatus: "",
    });
  };

  const getCleanFileName = (name, maxLength = 50) => {
    if (!name) return "";
    const cleaned = name.replace(/_/g, " ");
    return cleaned.length > maxLength
      ? cleaned.slice(0, maxLength) + "..."
      : cleaned;
  };

  return (
    <>
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ConfirmDialog
        open={dialogOpen}
        title="Confirm Popup"
        content="Are you sure you want to submit this record?"
        onClose={hanldeConfirmDialogCancel}
        onConfirm={hanldeConfirmDialogSubmit}
      />
      <Box sx={{ p: 3, mx: "auto", borderRadius: 2 }}>
        {/* <Loader isLoading={isLoading} /> */}
        <MessagePopup
          message={popup.message}
          severity={popup.severity}
          open={popup.open}
          setPopup={setPopup}
        />
        <ConfirmDialog
          open={dialogOpen}
          title="Confirm Popup"
          content="Are you sure you want to submit this record?"
          onClose={hanldeConfirmDialogCancel}
          onConfirm={hanldeConfirmDialogSubmit}
        />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", gap: 4 }}>
            <IconButton onClick={formClose}>
              <ArrowBackIcon sx={{ color: "#000" }} />
            </IconButton>{" "}
            <MaterialTypography
              sx={{ fontSize: "18px", fontWeight: "bold", mt: 2 }}
              mb={2}
            >
              New Insurance
            </MaterialTypography>
          </Box>
          <IconButton onClick={formClose}>
            <ClearIcon sx={{ color: "#000" }} />
          </IconButton>
        </Box>
        <Grid2 container spacing={1.5} sx={{ alignItems: "end" }}>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Insurance Name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="insurancename"
              placeholder="Enter Insurance Name"
              value={insurerdata.insurancename}
              onChange={handleAddCourseChange}
              error={insurerdata.insurancenameStatus === "error" ? true : false}
              success={
                insurerdata.insurancenameStatus === "success" ? true : false
              }
              disabled={inputStatus}
            />
            {insurerdata.insurancenameStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Insurance Name must be 1 to 50 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Insurance Type
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>

            <MaterialSelect
              name="insuranceType"
              placeholder={`Select insurance Type`}
              value={insurerdata.insuranceType}
              options={insurenceType?.map((v) => ({
                value: v?.id,
                label: v?.insurance_type,
              }))}
              searchable={false}
              onChange={handleAddCourseChange}
              error={insurerdata.insuranceTypeStatus === "error" ? true : false}
              success={
                insurerdata.insuranceTypeStatus === "success" ? true : false
              }
              isDisabled={inputStatus}
            />
            {insurerdata.insurancenameStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Insurance Name must be 1 to 50 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }} sx={{ paddingLeft: "2%" }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel, Opacity: "0" }}
            >
              Active/Inactive
            </MaterialTypography>
            <FormControlLabel
              control={
                <Switch
                  checked={insurerdata.active}
                  onChange={handleToggleActive}
                  color="primary"
                  disabled={inputStatus}
                />
              }
              disabled={inputStatus}
              label={insurerdata.active ? "Active" : "Inactive"}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              From Date
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              type="date"
              name="fromdate"
              placeholder="Select fromdate"
              value={insurerdata.fromdate}
              onChange={handleAddCourseChange}
              error={insurerdata.fromdateStatus === "error" ? true : false}
              success={insurerdata.fromdateStatus === "success" ? true : false}
              disabled={inputStatus}
            />
            {insurerdata.fromdateStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                From Date is required
              </MaterialTypography>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              ToDate
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              type="date"
              name="todate"
              placeholder="Select todate"
              value={insurerdata.todate}
              onChange={handleAddCourseChange}
              error={insurerdata.todateStatus === "error" ? true : false}
              success={insurerdata.todateStatus === "success" ? true : false}
              disabled={inputStatus}
            />
            {insurerdata.todateStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                ToDate is required
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Upload Logo
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <Box display="flex" alignItems="center">
              {insurerdata.uploadedFile == null && (
                <Button
                  variant="outlined"
                  component="label"
                  sx={{
                    flexGrow: 1,
                    height: 45,
                    textAlign: "left",
                    justifyContent: "flex-start",
                  }}
                >
                  {insurerdata.uploadedFile?.name || "Choose File"}
                  <input
                    type="file"
                    hidden
                    accept=".png,.jpg,.jpeg,.pdf,.doc,.docx"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const allowedTypes = ["image/png", "image/jpeg"];
                        if (!allowedTypes.includes(file.type)) {
                          setPopup({
                            open: true,
                            message: "PNG, JPG,",
                            severity: "error",
                          });
                        } else {
                          setinsurerdata((prev) => ({
                            ...prev,
                            uploadedFile: file,
                            imageUrl: null,
                          }));
                        }
                      }
                    }}
                  />
                </Button>
              )}
              {insurerdata.uploadedFile && (
                <Typography
                  variant="caption"
                  color="textSecondary"
                  sx={{ mt: 1, display: "block" }}
                >
                  {insurerdata.uploadedFile.name ||
                    insurerdata.uploadedFile.split("/").pop()}
                </Typography>
              )}
              {insurerdata.uploadedFile && (
                <IconButton
                  color="error"
                  onClick={() =>
                    setinsurerdata((prev) => ({ ...prev, uploadedFile: null }))
                  }
                  sx={{ ml: 1 }}
                  aria-label="delete file"
                >
                  <DeleteIcon />
                </IconButton>
              )}
            </Box>
            {insurerdata.imageUrl && (
              <img
                src={insurerdata.imageUrl}
                width={50}
                height={50}
                style={{ objectFit: "contain" }}
              />
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Parent Policy No
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="parentpolicyno"
              placeholder="Enter Policy No"
              value={insurerdata.parentpolicyno}
              onChange={handleAddCourseChange}
              error={
                insurerdata.parentpolicynoStatus === "error" ? true : false
              }
              success={
                insurerdata.parentpolicynoStatus === "success" ? true : false
              }
              disabled={inputStatus}
            />
            {insurerdata.parentpolicynoStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Policy No must be 1 to 50 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Upload Parent Policy
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>

            <Box display="flex" alignItems="center">
              {insurerdata.parentpolicyfile == null && (
                <Button
                  variant="outlined"
                  component="label"
                  sx={{
                    flexGrow: 1,
                    height: 45,
                    textAlign: "left",
                    justifyContent: "flex-start",
                  }}
                >
                  Choose File
                  <input
                    type="file"
                    hidden
                    accept=".pdf"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const allowedTypes = ["application/pdf"];
                        if (!allowedTypes.includes(file.type)) {
                          setPopup({
                            open: true,
                            message: "Only PDF files are allowed.",
                            severity: "error",
                          });
                        } else {
                          setinsurerdata((prev) => ({
                            ...prev,
                            parentpolicyfile: file,
                          }));
                        }
                      }
                    }}
                  />
                </Button>
              )}

              {insurerdata.parentpolicyfile && (
                <Typography
                  variant="caption"
                  color="textSecondary"
                  sx={{ mt: 1, display: "block" }}
                >
                  {getCleanFileName(insurerdata.parentpolicyfile.name)}
                </Typography>
              )}
              {insurerdata.parentpolicyfile && (
                <IconButton
                  color="error"
                  onClick={() =>
                    setinsurerdata((prev) => ({
                      ...prev,
                      parentpolicyfile: null,
                    }))
                  }
                  sx={{ ml: 1 }}
                  aria-label="delete file"
                >
                  <DeleteIcon />
                </IconButton>
              )}
            </Box>
          </Grid2>

          <Grid2 size={{ xs: 12, md: 4, md: 4 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Plan Name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="planName"
              placeholder="Enter Plan Name"
              value={insurerdata.planName}
              onChange={handleAddCourseChange}
              error={insurerdata.planNameStatus === "error" ? true : false}
              success={insurerdata.planNameStatus === "success" ? true : false}
              disabled={inputStatus}
            />
            {insurerdata.planNameStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Paln Name must be 1 to 50 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 2, md: 2 }}>
            <IconButton onClick={handleAddEntry}>
              <AddCircleIcon sx={{ color: colors.iconcolor }} />
            </IconButton>
          </Grid2>
          {entries.length > 0 && (
            <Grid2 size={{ xs: 12, md: 12, md: 12 }}>
              <div
                style={{
                  maxWidth: 800,
                  margin: "20px auto",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "1px solid #ccc",
                    fontSize: "12px",
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: "#f2f2f2" }}>
                      <th
                        style={{
                          textAlign: "left",
                          padding: 8,
                          border: "1px solid #ccc",
                        }}
                      >
                        No
                      </th>
                      <th
                        style={{
                          textAlign: "left",
                          padding: 4,
                          border: "1px solid #ccc",
                        }}
                      >
                        Paln Name
                      </th>
                      {!inputStatus && (
                        <th
                          style={{
                            textAlign: "center",
                            padding: 4,
                            border: "1px solid #ccc",
                          }}
                        >
                          Actions
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {entries.length === 0 ? (
                      <tr>
                        <td
                          colSpan={4}
                          style={{
                            padding: 4,
                            textAlign: "center",
                            color: "gray",
                            fontStyle: "italic",
                            border: "1px solid #ccc",
                          }}
                        >
                          No data available.
                        </td>
                      </tr>
                    ) : (
                      entries.map((entry, index) => (
                        <tr key={index}>
                          <td
                            style={{
                              padding: "2px 8px",
                              border: "1px solid #ccc",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              padding: "2px 8px",
                              border: "1px solid #ccc",
                            }}
                          >
                            {entry.plan_name}
                          </td>
                          {!inputStatus && (
                            <td
                              style={{
                                padding: "2px 8px",
                                textAlign: "center",
                                border: "1px solid #ccc",
                              }}
                            >
                              <IconButton
                                onClick={() => handleDeleteEntry(index)}
                                color="error"
                              >
                                <DeleteIcon sx={{ color: colors.iconcolor }} />
                              </IconButton>
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </Grid2>
          )}

          <Grid2 size={{ xs: 12, md: 12, md: 12 }}>
            <Box display="flex" justifyContent="space-around" mt={3}>
              {inputStatus == false && (
                <MaterialButton
                  variant="contained"
                  sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                  onClick={handleSubmit}
                  disabled={!isFormValid()}
                >
                  Submit
                </MaterialButton>
              )}
              <MaterialButton
                onClick={reset}
                variant="outlined"
                sx={{
                  color: colors.cancel,
                  borderColor: colors.cancel,
                  "&:hover": {
                    borderColor: colors.cancel,
                  },
                }}
              >
                Cancel
              </MaterialButton>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
};

export default AddInsurance;
